import { FieldBase } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/FieldBase';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Body, Heading, Switch } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function Guttage() {
  const { ctx } = useAnlageassistentContext();
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  return (
    <div className="flex flex-col gap-6 md:gap-4">
      <div className="flex flex-col gap-3">
        <Heading>{ctx.getCurrentSubStep()?.title}</Heading>

        <Body>
          {t('domain.mitarbeiter.create.steps.abwesenheiten.guttage.info')}
        </Body>
      </div>
      <form.AppField name="abwesenheiten.guttage.guttageBewerten">
        {(field) => (
          <FieldBase>
            <Switch
              id={field.name}
              name={field.name}
              checked={field.state.value}
              onCheckedChange={field.handleChange}
              onBlur={field.handleBlur}
              label={t(
                'domain.mitarbeiter.create.steps.abwesenheiten.guttage.form.guttageBewerten.label',
              )}
            />
          </FieldBase>
        )}
      </form.AppField>
    </div>
  );
}
